import { Message } from '../../types/chat'

interface MessageListProps {
  messages: Message[]
}

export function MessageList({ messages }: MessageListProps) {
  return (
    <div className="flex-1 overflow-y-auto p-4 space-y-4">
      {messages.length === 0 ? (
        <div className="text-center text-gray-500 mt-8">
          <p className="text-lg font-medium">Welcome to Heat Rules Assistant!</p>
          <p className="mt-2">Ask me anything about the Heat: Pedal to the Metal board game rules.</p>
        </div>
      ) : (
        messages.map((message) => (
          <div
            key={message.id}
            className={`flex ${
              message.role === 'user' ? 'justify-end' : 'justify-start'
            }`}
          >
            <div
              className={`max-w-3xl rounded-lg px-4 py-3 ${
                message.role === 'user'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-900'
              }`}
            >
              <div className="whitespace-pre-wrap break-words">
                {message.content}
              </div>
              {message.sources && message.sources.length > 0 && (
                <div className="mt-3 pt-3 border-t border-gray-300">
                  <p className="text-xs font-semibold mb-2 text-gray-700">
                    Sources:
                  </p>
                  <div className="space-y-1">
                    {Array.from(new Set(message.sources.map(s => `${s.source_name}|${s.page}`))).map((sourceKey) => {
                      const [source_name, pageStr] = sourceKey.split('|')
                      const page = parseInt(pageStr)
                      return (
                        <div key={sourceKey} className="text-xs text-gray-600">
                          {source_name}, p.{page}
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  )
}
